import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import getDate from 'date-fns/getDate'
import isSameMonth from 'date-fns/isSameMonth'
import isSameDay from 'date-fns/isSameDay'

type Props = {
  currentMonth: Date
  date: Date
  handleCaution: (flag: boolean) => void
  isActive: boolean
  isClosed: boolean
  isSet: boolean
  isSpecialHoliday: boolean
  selectSettingDate: (date: Date) => void
}

const IndividualScheduleCalendarCell: FC<Props> = React.memo((props) => {
  const { currentMonth, date, handleCaution, isActive, isClosed, isSet, isSpecialHoliday, selectSettingDate } = props

  const isToday = isSameDay(date, new Date())
  const isThisMonth = isSameMonth(date, currentMonth)

  const className = (() => {
    switch (true) {
      // 休業日・臨時休業日が祝日
      case isThisMonth && isSpecialHoliday && isClosed:
        return styles.table__cell__holiday_disabled
      // 休業日・臨時休業日
      case isThisMonth && isClosed:
        return styles.table__cell_disabled
      // 個別設定日
      case isThisMonth && isSet:
        return styles.table__cell_set
      // 受渡可能日
      case isThisMonth && isActive:
        return styles.table__cell_active
      // 当日が祝日
      case isThisMonth && isSpecialHoliday && isToday:
        return styles.table__cell__holiday_today
      // 当日
      case isThisMonth && isToday:
        return styles.table__cell_today
      // 通常日が祝日
      case isThisMonth && isSpecialHoliday:
        return styles.table__cell__holiday
      default:
        return styles.table__cell
    }
  })()

  const onClick = () => {
    switch (true) {
      case !isThisMonth:
        return handleCaution(false)
      case isClosed:
        return handleCaution(true)
      default:
        handleCaution(false)
        return selectSettingDate(date)
    }
  }

  return (
    <td className={className} onClick={onClick}>
      <span className={styles.table__cell__date}>{isThisMonth ? getDate(date) : ''}</span>
    </td>
  )
})

export default IndividualScheduleCalendarCell
